import { getField, updateField } from 'vuex-map-fields'
import api from '@/lib/api'
import { NOT_STARTED, IN_PROGRESS, COMPLETE, ERROR } from '@/lib/constants/actionStatuses'
import { PATH_WORKFLOW_INSTANCES } from '@/lib/constants/api'
import getWorkflowInstanceModel from './models/workflowInstance'
import updateStatus from '@/store/helpers/updateStatus'
import { notifySuccess, notifyError } from '@/lib/notifications'
import { hideProgressModal, showProgressModal } from '@/lib/progressModal'

const workflowInstance = {
  namespaced: true,
  state: {
    ...getWorkflowInstanceModel()
  },
  getters: {
    getField
  },
  mutations: {
    updateField,
    updateStatus,
    clearWorkflowInstance: (state) => {
      const model = getWorkflowInstanceModel()
      Object.keys(model).forEach(key => { state[key] = model[key] })
    },
    setWorkflowInstance: (state, instance) => {
      Object.keys(instance).forEach(key => { state[key] = instance[key] })
    }
  },
  actions: {
    getWorkflowInstance: ({ commit, dispatch }, { id }) => {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Loading instance, please wait...' })

      return api.doGet({ path: `${PATH_WORKFLOW_INSTANCES}/${id}` })
        .then(json => json.data)
        .then(instance => {
          commit('setWorkflowInstance', instance)
          commit('updateStatus', { status: COMPLETE })
          return instance
        }).catch((error) => {
          commit('updateStatus', { status: ERROR, error })
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    },
    updateInstanceStatus: ({ commit, dispatch }, { id, statusId }) => {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Updating status, please wait...' })

      return api.doPut({ path: `${PATH_WORKFLOW_INSTANCES}/${id}/status`, data: { statusId } })
        .then(response => {
          if (!response.data) {
            throw new Error(response.errorMessage || 'Unable to update status')
          }
          commit('setWorkflowInstance', response.data)
          commit('updateStatus', { status: COMPLETE })
          notifySuccess(dispatch, 'Status updated')
          return response.data
        }).catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          notifyError(dispatch, error || 'Unable to update status')
          throw error
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    },
    clearWorkflowInstance: ({ commit }) => {
      commit('clearWorkflowInstance')
      return commit('updateStatus', { status: NOT_STARTED })
    }
  }
}

export default workflowInstance
